module.exports = __webpack_public_path__ + "static/img/companyProfileLogo.c3af824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companyProfileLogo.png
// module id = ZqY8
// module chunks = 2